import { Component, OnInit, ViewChild } from '@angular/core';
import { CustomHeaderComponent } from '../../component/custom-header/custom-header.component';
import { ActivatedRoute } from "@angular/router";
import { CommonService } from '../../shared/common';
import { messages } from 'src/app/shared/constants';
import { GlobalsService } from '../../shared/globals';
import { ModalController } from '@ionic/angular';
import { ActivityhistoryService } from '../../services/activityhistory.service';
import { IonInfiniteScroll } from '@ionic/angular';
@Component({
  selector: 'app-activityhistory',
  templateUrl: './activityhistory.page.html',
  styleUrls: ['./activityhistory.page.scss'],
})
export class ActivityhistoryPage implements OnInit {
  @ViewChild(IonInfiniteScroll, { static: true }) infiniteScroll: IonInfiniteScroll;

  count = 0;
  isRecordExists = true;
  public title = "";
  activityHistory = [];
  constructor(
    private customHeader: CustomHeaderComponent,
    private route: ActivatedRoute,
    private commonService: CommonService,
    private globals: GlobalsService,
    public modalController: ModalController,
    public activityHistoryService: ActivityhistoryService
  ) { }

  ngOnInit() {
    this.commonService.assignGlobals();
    this.route.queryParams.subscribe(params => {
      this.title = params["Title"];
    });
    this.getActivityHistory(null);
  }
  loadData(event) {
    setTimeout(() => {
      console.log('Done');
      event.target.complete();
      this.getActivityHistory(event);

      // if (data.length == 1000) {
      //   event.target.disabled = true;
      // }
    }, 500);
  }
  async getActivityHistory(event) {
    if (navigator.onLine) {
      //this.activityHistory = [];
      let loader;
      if (event == null) {
        loader = await this.commonService.showLoading(messages.ALLACTIVITYHISTORY);
      }
      this.activityHistoryService
        .getActivityHistory(this.count)
        .then((data: any) => {
          if (event == null) {
            loader.dismiss();
          }
          if (data.length > 0) {
            this.isRecordExists = true;
            data.forEach(element => {
              if(element.IsVoiceCommand){
                element.IsVoiceCommand = 'YES';
              }else{
                element.IsVoiceCommand = 'NO';
              }
              this.activityHistory.push(element);
              this.count++;
            });
          } else {
            if (event != null) {
              event.target.disabled = true;
            }
          }
        })
        .catch((e) => {
          if (event == null) {
            loader.dismiss();
          }
        });
    } else {
      this.commonService.showAlert(messages.ALERTTITLINFORMATION, messages.PLEASECONNECTTONETWORK, ['OK']);
    }
  }

}
